export default function(height) {
  return {
    type: "SET_HEIGHT",
    height
  }
}



// WEBPACK FOOTER //
// ./src/actions/setHeight.js